module.exports = __webpack_public_path__ + "img/resp-career.71b2dc98.svg";